import type { JSX, ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, body, action }: EmptyStateProps): JSX.Element {
  return (
    <div
      className="flex flex-col items-center gap-3 px-6 py-16 text-center"
      data-testid="empty-state"
    >
      {icon && (
        <div className="grid h-12 w-12 place-items-center rounded-full bg-[var(--surface-sunken)] text-[var(--text-subtle)]">
          {icon}
        </div>
      )}
      <p className="text-sm font-semibold text-[var(--text-primary)]">{title}</p>
      {body && <p className="max-w-sm text-sm text-[var(--text-subtle)]">{body}</p>}
      {action}
    </div>
  );
}
